import React, { useEffect, useCallback, useState } from 'react'
import type { FC, ComponentType } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, useHistory } from 'react-router-dom'
import type { RouteProps } from 'react-router-dom'
import { notification, Spin, Modal } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'
// import { isAuth } from '@/utils/auth'
import { routeBack } from '@/store/actions/common.action'
import { authsignin, getAuth, signup } from '@/store/actions/auth.action'
import type { IAppState } from '@/store/reducers'
import { SmileOutlined } from '@ant-design/icons'
// import { debounce } from '@/utils/util'
import { setSessionRequestMsg, getSessionRequestMsg } from '@/router'
import { t } from 'i18next'
import { useTranslation } from 'react-i18next'
import { ifvisible } from '@/components/ifvisible.js/main'

interface PrivateRouteProps extends RouteProps {
  component: ComponentType<any>
}

interface fn {
    (): void
}

const notifyMsg = (requestMsg: string): void => {
    if (requestMsg) {
        const sessionRequest = getSessionRequestMsg()
        console.log('sessionStorage requestMsg privateRoute: ', sessionRequest)
        if (sessionRequest) {
            setTimeout(() => {
                setSessionRequestMsg('')
            }, 1000)
            return
        }
        setSessionRequestMsg(requestMsg)
        setTimeout(() => {
            setSessionRequestMsg('')
        }, 1000)
        const args = {
            message: requestMsg.split('--').shift(),
            description: '',
            icon: <SmileOutlined style={{ color: '#e1931e' }} />,
            duration: 3,
        }
        notification.open(args)
    }
}

const PrivateRoute: FC<PrivateRouteProps> = ({
    component: Component,
    ...rest
}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { i18n } = useTranslation()
    const { location } = history
    const signinState = useSelector((state: IAppState) => state.auth.signin)
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const requestMsg = useSelector((state: IAppState) => state.common.message)
    const [pop, setPop] = useState(false)
    const { confirm } = Modal
    
    const time = 60 * 60 // 1小时

    const idleHandler = useCallback(function () {
        console.log('idle')
        if (!pop) {
            confirm({
                title: `${t('your has')}${time / 60}${t('minutes')}${t('no works')}, ${t('is continue')}?`,
                icon: <ExclamationCircleFilled />,
                centered: true,
                maskClosable: false,
                okText: t('continue'),
                cancelText: t('quit'),
                onOk() {
                    setPop(false)
                },
                onCancel() {
                    setPop(false)
                    dispatch(signup(t('logout') + (i18n.language !== 'zh' ? ' ' : '') + t('success')))
                },
            })
            setPop(true)
            releaseIfVisibleEvent()
        }
    }, [])
    const statusChangedHandler = useCallback(function () {
        // console.log('statusChanged: ', e)
    }, [])
    const wakeupHandler = useCallback(function() {
        // console.log('wakeup')
    }, [])

    // 检测用户久无操作 过期提示
    const registIfVisibleEvent = ({ statusChangedHandler, idleHandler, wakeupHandler }: {
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        statusChangedHandler: (e: any) => void
        idleHandler: fn
        wakeupHandler: fn
    }): void => {
        ifvisible.on('statusChanged', statusChangedHandler)
        ifvisible.idle(idleHandler)
        ifvisible.wakeup(wakeupHandler)
    }
    const releaseIfVisibleEvent = (): void => {
        ifvisible.off('idle')
        ifvisible.off('wakeup')
        ifvisible.off('statusChanged')
    }

    const setIfVisible = (): void => {
        ifvisible.setIdleDuration(time)
    }

    useEffect(() => {
        setIfVisible()
    }, [])
    useEffect(() => {
        if (!pop) {
            // 开始计时
            registIfVisibleEvent({ statusChangedHandler, idleHandler, wakeupHandler })
        }
        return () => {
            // 释放事件
            console.log('退出页面时释放事件')
            releaseIfVisibleEvent()
        }
    }, [pop])
    useEffect(() => {
        // 验证登录是否过期
        dispatch(authsignin())
        // 如果没有权限，则重新获取
        if (!authInfo) {
            dispatch(getAuth())
        }
    }, [location])
    // 公共错误
    useEffect(() => {
        // debounceNotify(requestMsg)
        notifyMsg(requestMsg)
    }, [requestMsg])
    useEffect(() => {
        // 登录验证时错误 并且 不是已退出登录状态
        if (signinState.loaded && !signinState.success) {
            if (signinState.message) {
                notifyMsg(signinState.message)
            }
            console.log('location: ', location)
            const { pathname, search, state } = location
            // 记录当前页面, 以便登录后回转
            dispatch(routeBack(pathname, search, state))
            history.replace('/login', state)
        }
    }, [signinState])

    return signinState.loaded ? (
        <Route
            {...rest}
            render={props => <Component {...props} />}
        />
    ) : (
        <div 
            style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        ><Spin size="large" /></div>
    )
}

export default PrivateRoute
